<template>
  <v-container
    pa-0
    ma-0
    class="overflow-hidden"
  >
    <v-layout
      row
      wrap
      align-center
    >
      <v-flex>
        <v-flex
          pb-2
          mb-0
          text-xs-center
          class="tw-p-0 tw-m-0"
        >
          Won vs. Lost
        </v-flex>

        <v-flex
          pt-0
          mt-0
          text-xs-center
          shrink
          class="overflow-hidden"
        >
          <apexchart
            :options="options"
            :series="options.series"
            :type="options.chart.type"
            width="100%"

            class="tw-self-center tw-overflow-hidden shrink tw--mb-10"
          />
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
    export default {
        data() {
            return {
                options: {
                    series: [75],
                    chart: {
                        type: 'radialBar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: -135,
                            endAngle: 225,
                            hollow: {
                                margin: 0,
                                size: '70%',
                                background: '#fff',
                                position: 'front',
                                dropShadow: {
                                    enabled: true,
                                    top: 3,
                                    left: 0,
                                    blur: 4,
                                    opacity: 0.24,
                                },
                            },
                            track: {
                                background: '#fff',
                                strokeWidth: '67%',
                                margin: 0, // margin is in pixels
                                dropShadow: {
                                    enabled: true,
                                    top: -3,
                                    left: 0,
                                    blur: 4,
                                    opacity: 0.35,
                                },
                            },

                            dataLabels: {
                                name: {
                                    offsetY: -10,
                                    show: true,
                                    color: '#888',
                                    fontSize: '17px',
                                },
                                value: {
                                    formatter: function(val) {
                                        return parseInt(val);
                                    },
                                    color: '#111',
                                    fontSize: '36px',
                                    show: true,
                                },
                            },
                        },
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            type: 'horizontal',
                            shadeIntensity: 0.5,
                            gradientToColors: ['#ABE5A1'],
                            inverseColors: true,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [0, 100],
                        },
                    },
                    stroke: {
                        lineCap: 'round',
                    },
                    labels: ['Percent'],
                },
            };
        },
    };
</script>
